import { HelmetDexteel } from "@dexteel/mesf-core";
import { ProductChangesManager } from "./components/ProductChangesManager";

export const ProductChangesPage = () => {
	return (
		<>
			<HelmetDexteel title="Product Changes" />
			<ProductChangesManager />
		</>
	);
};
